export const languages = [
    {slug: "it", value: "Italiano"},
    {slug: "en", value: "Inglese"},
    {slug: "el", value: "Greco"}
];